import initialState from 'src/store/state'

// Target State
const moduleState = initialState.status

// Actions
const SET_TALK_START = 'SET_TALK_START'
const SET_QUESTIONNAIRE_ENDED = 'SET_QUESTIONNAIRE_ENDED'
const SET_MAINTENANCE = 'SET_MAINTENANCE'
const SET_PREV_RESULT = 'SET_PREV_RESULT'
const SET_PREV_RESULT_START = 'SET_PREV_RESULT_START'
const SET_SHOW_RESTART = 'SET_SHOW_RESTART'
const SET_SHOP_QR = 'SET_SHOP_QR'
const SET_SHOP_QR_UNKNOWID = 'SET_SHOP_QR_UNKNOWID'
const SET_EC = 'SET_EC'
//TODO: 最初のshopぱらめたチェックしてpost値を定義 status.shop_qr

// Action Creators
export const setTalkStart = (bool:boolean) => {
  return {
    type: SET_TALK_START,
    payload: bool
  }
}

export const setEC = (n:number) => {
  return {
    type: SET_EC,
    payload: n 
  }
}

export const setShopQr = (n:number) => {
  return {
    type: SET_SHOP_QR,
    payload: n 
  }
}

export const setShopQrUnknowID = (bool:boolean) => {
  return {
    type: SET_SHOP_QR_UNKNOWID,
    payload: bool 
  }
}

export const setQuestionnaireEnded = (bool:boolean) => {
  return {
    type: SET_QUESTIONNAIRE_ENDED,
    payload: bool
  }
}

export const setMaintenance = (bool:boolean) => {
  return {
    type: SET_MAINTENANCE,
    payload: bool
  }
}

export const setPrevResult = (str:string) => {
  return {
    type: SET_PREV_RESULT,
    payload: str
  }
}

export const setPrevResultStart = (bool:boolean) => {
  return {
    type: SET_PREV_RESULT_START,
    payload: bool
  }
}

export const setShowRestart = (bool:boolean) => {
  return {
    type: SET_SHOW_RESTART,
    payload: bool
  }
}

// Reducers
const reducers = (state = moduleState, action:any) => {
  switch (action.type) {
    case SET_TALK_START:
      return Object.assign({}, state, {
        isTalkStart: action.payload
      })

    case SET_EC:
      return Object.assign({}, state, {
        referrerEC: action.payload
      })

    case SET_SHOP_QR_UNKNOWID:
      return Object.assign({}, state, {
        isUnknowID: action.payload
      })

    case SET_SHOP_QR:
      return Object.assign({}, state, {
        shopQR: action.payload
      })


    case SET_QUESTIONNAIRE_ENDED:
      return Object.assign({}, state, {
        isQuestionnaireEnded: action.payload
      })

    case SET_MAINTENANCE:
      return Object.assign({}, state, {
        isMaintenance: action.payload
      })

    case SET_PREV_RESULT:
      return Object.assign({}, state, {
        prevResult: action.payload
      })

    case SET_PREV_RESULT_START:
      return Object.assign({}, state, {
        isPrevResultStart: action.payload
      })

    case SET_SHOW_RESTART:
      return Object.assign({}, state, {
        showRestart: action.payload
      })

    default:
      return state
  }
}

export default reducers
